// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"skuimage_imageWrapper__Zzkze","image":"skuimage_image__IbpyL","fadein":"skuimage_fadein__RrW_8","loading":"skuimage_loading___vP9k"};